import { createSelector } from '@reduxjs/toolkit';
import { discoverApi } from '../discover-api';

const selectGetTrendingSearches =
    discoverApi?.endpoints.getTrendingSearches.select(undefined);
export const selectTrendingSearches = () =>
    createSelector(
        selectGetTrendingSearches,
        (trendingSearches) => trendingSearches?.data ?? []
    );
